import {
  mediaCategoryTypes as actionTypes,
  marketplaceMediaCategoryTypes as marketplaceActionTypes,
} from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default({ collection: true, localized: true }),
};

export const mediaCategoryList = (state = defaultState, action) =>
  commonReducer(actionTypes, state, action);

export const marketplaceMediaCategoryList = (state = defaultState, action) =>
  commonReducer(marketplaceActionTypes, state, action);
